import React, { Component } from 'react';
import SupportMail from '../../Integrations/SupportMail';
import './style.scss';
import { urlName } from '../../../config';
import { domainNames } from '../../../utils/domainNameList';
import { defaultDomains } from '../../../utils/defaultDomainList';

export default class VerifyPage extends Component {
    render() {
        return (
            <div className='verify-page-wrapper'>
                <section className='left-section'>
                    <div className='header'>
                        <div className='header-image'>
                            <img src={this.props.domainIcon}></img>
                        </div>
                        <h1 className='header-text'>
                           {domainNames[urlName]}
                        </h1>

                    </div>
                    <div className='background-image-block'>
                        <div className='head-section'>
                        {defaultDomains.includes(urlName) && <img src='https://skyeline.com/wp-content/uploads/2022/02/Jim-DeMicco-768x768.jpg'></img>}
                            <div className='review-details'>
                                <span className='reviewer'>
                                {defaultDomains.includes(urlName) && 'Jim D'}
                                </span>
                                <span className='reviewer-details'>
                                {defaultDomains.includes(urlName) && 'Co-Founder, Creative Director'}
                                </span>

                            </div>

                        </div>
                        <div className='review'>
                            {defaultDomains.includes(urlName) && "LocalClarity is not just about offering a top-notch platform for managing reviews, especially for multiple restaurant locations like ours. What truly sets them apart is their stellar support team. The value they deliver, both in product and service, far surpasses many other platforms in the market."}

                        </div>
                    </div>
                    <div className='footer-section'>
                        <span className='step-count'> Step 1</span>
                        <div className='footer-description-block'>
                            <h2 className='description-label'>
                                Verify Email address

                            </h2>
                            <span className='desciption-content'>
                                As a security measure, verify the email address used to create our user account

                            </span>
                        </div>
                        <span className='page-indicatior'>
                            <span class="line active"></span>
                            <span class="line "></span>
                            <span class="line "></span>
                            <span class="line "></span>
                        </span>

                    </div>
                </section>
                <section className='right-section'>
                    <div className='verification-content-block'>
                        <p>
                            You will receive an email with a link to verify your new user account.
                        </p>
                        <p>
                            Click the link in the email to return to the platform and set your first integrations.
                        </p>
                    </div>
                    <div className='verification-contact'>
                        {`If you don't receive an email, please reach out to us at ${SupportMail[urlName]}`}
                    </div>
                </section>
            </div>
        )
    }
}
